module.exports = __webpack_public_path__ + "media/images/redesign-images/essentials/perfect/perfect-13-82d661ffa880e4cb013454f4f546112a.jpg";